import PersonIcon from './PersonIcon'

export default PersonIcon
